import { Component, OnInit } from '@angular/core';
export class NotaInicioComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-nota-inicio',
  template: `
    <a routerLink="/nota-aluno/tradicional/4/11/15009785/559935" routerLinkActive="active">
      <button class="btn btn-success ">Tradicional</button>
    </a>
    <a routerLink="/nota-aluno/pos/3/4/224359" routerLinkActive="active">
      <button class="btn btn-success ">Pós</button>
    </a>
    <a routerLink="/nota-aluno/colegio/2/2/1708813/628391/4" routerLinkActive="active">
      <button class="btn btn-success ">Colégio</button>
    </a>
    <a routerLink="/nota-aluno/colegio/2/2/1708813/628391/7" routerLinkActive="active">
      <button class="btn btn-danger ">Colégio BLOQUEADO</button>
    </a>
    <a routerLink="/nota-aluno/pbl/8/48/15109909/633652" routerLinkActive="active">
      <button class="btn btn-success ">PBL</button>
    </a>
    <br>
    <app-notificacao-nota-aluno></app-notificacao-nota-aluno>
      <router-outlet></router-outlet>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NotaInicioComponent_tsickle_Closure_declarations() {
/** @type {?} */
NotaInicioComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotaInicioComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
